// ProjectLoadDialog.tsx — Open a saved project from IndexedDB
// Lists all saved projects with name, date, panel count

import { useEffect, useState } from 'react';
import DialogBase from './DialogBase';
import { useStore } from '../store/useStore';
import { db } from '../store/db';

interface Row { id: string; name: string; updatedAt: string; panelCount: number; }

export default function ProjectLoadDialog() {
  const loadProject = useStore(s => s.loadProject);
  const [rows, setRows] = useState<Row[]>([]);
  const [selected, setSelected] = useState<string>('');

  useEffect(() => {
    db.projects
      .orderBy('updatedAt')
      .reverse()
      .toArray()
      .then(all => {
        setRows(all.map(r => ({
          id:         r.id,
          name:       r.name,
          updatedAt:  r.updatedAt,
          panelCount: r.panels?.length ?? 0,
        })));
      });
  }, []);

  return (
    <DialogBase
      title="Open Project"
      onOk={() => selected && loadProject(selected)}
      okLabel="Open"
    >
      {rows.length === 0 && (
        <p className="dialog-empty">No saved projects found.</p>
      )}
      <ul className="project-list">
        {rows.map(r => (
          <li
            key={r.id}
            className={`project-list-item${r.id === selected ? ' selected' : ''}`}
            onClick={() => setSelected(r.id)}
            onDoubleClick={() => { setSelected(r.id); loadProject(r.id); }}
          >
            <span className="plname">{r.name}</span>
            <span className="plmeta">
              {r.panelCount} panel{r.panelCount !== 1 ? 's' : ''} · {new Date(r.updatedAt).toLocaleDateString()}
            </span>
          </li>
        ))}
      </ul>
    </DialogBase>
  );
}
